import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { changeDateFormat, tableDesign } from '../app/consts';
import { Link } from 'react-router-dom';
import { getAllWorkoutsAsync, selectLimitedWorkouts } from '../features/add_workout/workoutSlice';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

const Home = () => {
    const workoutsArr = useAppSelector(selectLimitedWorkouts)
    const dispatch = useAppDispatch()
    const [hold, setHold] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showOnlyBasic, setShowOnlyBasic] = useState(true)
    const [showModal, setShowModal] = useState(false)

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        setHold(true)
        dispatch(getAllWorkoutsAsync()).unwrap().then(() => {
            setHold(false)
        })
            .catch((err) => console.error("Handled error:", err))
        // eslint-disable-next-line
    }, [])

    const handleModalClose = (onlyBasic: boolean = true) => {
        setShowModal(false);
        setShowOnlyBasic(onlyBasic);
    };

    const filteredData = workoutsArr?.filter((value) => showOnlyBasic ? value?.type?.name === "בסיס" : value?.type?.name !== "בסיס")?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <div>
            <div style={{ textAlign: 'center' }}>
                <h1>מערכת לניהול אימונים</h1>
                {hold ?
                    <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                    :
                    <>
                        {
                            showOnlyBasic ?
                                <Button onClick={() => setShowModal(true)} variant="contained" color='inherit'>הצג אימונים מתקדמים</Button>
                                :
                                <Button onClick={() => setShowOnlyBasic(true)} variant="contained" color='inherit'>הצג אימוני בסיס</Button>
                        }
                        <br /><br />
                        {filteredData.length === undefined || filteredData.length === 0 ?
                            <h2>{showOnlyBasic ?
                                "אין כרגע אימוני בסיס זמינים להרשמה"
                                :
                                "אין כרגע אימונים מתקדמים זמינים להרשמה"
                            }</h2>
                            :
                            <>
                                <h2> {showOnlyBasic ? "אימוני בסיס" : "אימונים מתקדמים"} פתוחים להרשמה</h2>
                                <Paper sx={tableDesign}>
                                    <TableContainer sx={{ maxHeight: 300 }}>
                                        <Table stickyHeader aria-label="sticky table" sx={{ "& .MuiTableCell-root": { fontSize: "1em", textAlign: 'center' } }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>תאריך ושעה</TableCell>
                                                    <TableCell>סוג האימון</TableCell>
                                                    <TableCell>מדריך</TableCell>
                                                    <TableCell>מיקום</TableCell>
                                                    <TableCell>הערות לאימון</TableCell>
                                                    <TableCell>קישור להרשמה</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredData?.map((value: any, index: number) =>
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {changeDateFormat(value.date)} - {(value.time as string).slice(0, -3)}
                                                        </TableCell>
                                                        <TableCell>{value.type.name}</TableCell>
                                                        <TableCell>{value.instructor.fullName}</TableCell>
                                                        <TableCell>{value.location}</TableCell>
                                                        <TableCell>{value.notes}</TableCell>
                                                        <TableCell>
                                                            {value.link === "האימון מלא" ?
                                                                <span style={{color:"orange"}}>{value.link}</span>
                                                                :
                                                                <Link to={`${window.location.origin}${value.link}`} relative='path'>הרשמה לאימון זה</Link>
                                                            }
                                                        </TableCell>
                                                    </TableRow>)
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 20]}
                                        component="div"
                                        count={filteredData.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        sx={{ justifySelf: 'right', direction: 'ltr' }}
                                    />
                                </Paper>
                            </>
                        }
                    </>}
            </div >
            <Dialog
                open={showModal}
                onClose={handleModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    הצגת אימונים מתקדמים
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        אני מאשר שאני עומד בדרישות לאימונים מתקדמים
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleModalClose(true)}>לא מאשר</Button>
                    <Button onClick={() => handleModalClose(false)} autoFocus>
                        מאשר
                    </Button>
                </DialogActions>
            </Dialog>

        </div >
    )
}

export default Home